import React, { useState, useEffect } from "react";

const LOGO = "https://customer-assets.emergentagent.com/job_2e8a6a93-30a9-4e91-a7a5-a9394acf49bd/artifacts/xwzvhvs5_Header%20Logo%20Ethia.png";

const MaroonNavbar = ({ onOrder }) => {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const h = () => setScrolled(window.scrollY > 60);
    window.addEventListener("scroll", h);
    return () => window.removeEventListener("scroll", h);
  }, []);

  const links = [
    { href: "/about", label: "About Us" },
    { href: "/science", label: "Science" },
    { href: "/products", label: "Products" },
    { href: "/early-access", label: "Early Access" },
    { href: "/contact", label: "Contact" },
  ];

  const handleOrder = () => {
    if (onOrder) onOrder();
    else window.location.href = "/products";
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-shadow duration-300 ${scrolled ? "shadow-2xl" : ""}`}
      style={{ background: "#5C0F1C" }}
      data-testid="maroon-navbar"
    >
      <div className="max-w-[1380px] mx-auto px-4 md:px-[52px] py-3 md:py-4">
        <div className="flex items-center justify-between">
          <a href="/"><img src={LOGO} alt="ETHIA" className="h-12 md:h-20" data-testid="nav-logo" /></a>
          <div className="hidden md:flex items-center gap-8">
            {links.map((l) => (
              <a key={l.label} href={l.href} className="text-white/90 hover:text-white transition-colors font-medium text-sm" style={{ fontFamily: "Manrope, sans-serif" }}>{l.label}</a>
            ))}
            <button onClick={handleOrder} className="font-semibold px-6 py-2.5 rounded-full transition-all hover:scale-105" style={{ background: "#F5C800", color: "#621B21", fontFamily: "Manrope, sans-serif" }} data-testid="nav-order-btn">Order Now</button>
          </div>
          <div className="flex items-center gap-3 md:hidden">
            <button onClick={handleOrder} className="font-semibold px-4 py-2 rounded-full text-sm" style={{ background: "#F5C800", color: "#621B21" }} data-testid="nav-order-btn-mobile">Order Now</button>
            <button onClick={() => setMenuOpen(!menuOpen)} className="text-white p-1" data-testid="nav-menu-toggle">
              {menuOpen ? <span className="text-2xl">&#10005;</span> : <span className="text-2xl">&#9776;</span>}
            </button>
          </div>
        </div>
      </div>
      {menuOpen && (
        <div className="md:hidden border-t border-white/10 px-4 py-4 space-y-1" style={{ background: "#5C0F1C" }}>
          {links.map((l) => (
            <a key={l.label} href={l.href} onClick={() => setMenuOpen(false)} className="block text-white hover:text-yellow-300 font-medium py-3 px-4 rounded-xl transition-colors">{l.label}</a>
          ))}
        </div>
      )}
    </nav>
  );
};

export default MaroonNavbar;
